import * as React from 'react';

import classNames from 'classnames';

import {
  AssignmentInfo,
  getLeadershipTerms,
  mapRoleLabelForRotaractors,
} from '../utils';

import { getClubRoleTValue } from '@utils/getClubRoleTValue';

import { useTranslation } from '@external/react-i18next';

import { Maybe, MembershipType } from '@typings/graphql';

const RoleAndTypeLabel: React.FC<{
  role?: AssignmentInfo;
  type: MembershipType | undefined;
  isDeceased?: Maybe<boolean>;
  dates: Maybe<string>;
  wrapperClasses?: string;
}> = ({ role, type, isDeceased, dates, wrapperClasses }) => {
  const { t } = useTranslation();
  const { roleName, terms } = role || {};

  let roleLabel;

  if (roleName || type) {
    roleLabel = (roleName && getClubRoleTValue(t, roleName)) || type;
    if (isDeceased) {
      roleLabel = t(
        'roster-result.member.role-deceased',
        '{{ role }} (deceased)',
        {
          role: roleLabel,
        }
      );
    }
  }

  roleLabel = mapRoleLabelForRotaractors(t, roleLabel);

  return (
    <div className={classNames('text-xs', wrapperClasses)}>
      <div>{roleLabel}</div>
      {dates && <div>{dates}</div>}
      {terms && (
        <div className="mobile-l:pr-20">
          {getLeadershipTerms(terms).join(', ')}
        </div>
      )}
    </div>
  );
};

export default RoleAndTypeLabel;
